// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fbc9665f","977":"1de28a69"}[chunkId] + ".chunk.js";
};